import Cookie from './cookie'
import _get from 'lodash.get'
const { localStorage, location } = window

const href = function (url) {
  if (location.pathname.startsWith('/luban/') && +url) {
    let arr = location.href.split('/')
    arr[5] = url
    location.href = arr.join('/')
  } else {
    location.href = url
  }
}

/**
 * 格式化当前url中的参数
 */
const formatUrlQuery = () => {
  let params = location.search.slice(1).split('&')
  let query = {}
  params.forEach(param => {
    let [k, v] = param.split('=')
    if (query[k]) { // 处理同名参数
      if (!Array.isArray(query[k])) {
        query[k] = [query[k]]
      }
      query[k].push(v)
    } else {
      query[k] = v
    }
  })
  return query
}

/**
 * 根据类型获取对应参数值
 * @param {Object} obj 获取参数对象
 * @example
 * 从url中获取query为id的参数值
 * {
 *  type: 'url',
 *  value: 'id'
 * }
 */
const getResquestParam = (obj) => {
  let urlQuery = formatUrlQuery()
  let type = obj.type
  let value = ''

  switch (type) {
    case 'url':
      value = urlQuery[obj.value]
      break
    case 'cookie':
      value = Cookie.get(obj.value)
      break
    case 'localStorage':
      value = localStorage.getItem(obj.value)
      break
    case 'fiexd': // 固定值
      value = obj.value
      break
  }

  return value || ''
}

/**
 * 从接口中返回指定条件key的值
 * @param {Object} obj 结果获取条件对象
 * @param {Object} result 接口请求返回结果
 */
const getResponseData = (obj, result) => {
  if (obj.type === 'api') {
    return _get(result, obj.value)
  }
  return obj.value
}

/**
 * 埋点上报
 * @param {Function} sdData sdData
 * @param {Object} trackData 上报数据对象
 * @param {Function} cb 上报成功回调
 */
const track = function (sdData, trackData, cb = () => {}) {
  let { type = 'click', code = 0, extInfo = {} } = trackData || {}
  // 没有code不上报
  if (!code) {
    return cb()
  }
  sdData.track(type, {
    elementCode: code,
    extInfo
  }, cb)
}

export default {
  getResquestParam,
  getResponseData,
  track,
  href
}
